let API = require('./index');

module.exports = {
    register (locator) {
        locator.register('api', API, true);
    }
};



// WEBPACK FOOTER //
// ./services/api/register.js